export default {
    workflows: 'Workflows',
    search: 'Search workflows',
    'empty-list': 'No workflows has been created yet',
    'empty-filtered-list': 'No workflows found',
    'list-header': {
        name: 'Name',
        id: 'Workflow ID',
        type: 'Type',
        created: 'Created',
        revision: 'Revision',
        actions: 'Actions',
    },
    tooltip: {
        copy: 'Copy',
        run: 'Run workflow',
        params: 'Define workflow params',
        edit: 'Edit',
        delete: 'Delete',
    },
    revision: {
        label: 'Revision',
        activate: 'Activate',
        active: 'Active',
        notify: {
            selected: 'Revision {revision} has been loaded',
            activated: 'Revision {revision} is now active',
        },
    },
    'generate-link': {
        button: 'Run',
        title: 'Generated link to preview workflow "{name}"',
        'button-open': 'Open in new window',
        'button-copy-token': 'Copy token',
        'case-teaser': {
            description: 'Finish your workflow, let your dashboard light up with cases!',
        },
    },
    'define-workflow-params': {
        title: 'Define parameters for "{name}"',
        'add-param': 'Add parameter',
        'add-value': 'Add value',
        saved: 'The parameters have been successfully saved.',
        label: {
            required: 'Required',
            optional: 'Optional',
            type: 'Type',
            'item-type': 'Item type',
            validator: 'Validator',
            delete: 'Delete',
        },
        button: 'Save',
    },
    'fill-workflow-params': {
        title: 'Specify workflow parameters',
        saved: 'Workflow parameters have been successfully saved',
        button: 'Save values',
    },
    'case-management-button': 'See cases',
    'make-copy': {
        button: 'Copy',
    },
    form: {
        name: 'Workflow name',
    },
    'create-new': {
        button: 'New Workflow',
        description: 'Start building your workflows',
        'onboarding-workflow': 'Onboarding Workflow',
        'monitoring-workflow': 'Monitoring Workflow',
    },
    'delete-confirm': {
        title: 'Are you sure you want to remove "{name}"?',
        description: 'This action cannot be undone.',
    },
    'close-builder-confirm': {
        'has-changes': 'There are unsaved changes in the workflow. Are you sure you want to close the builder?',
        'has-error': 'We experienced an error while saving the workflow. Are you sure you want to close the builder?',
    },
    'success-response': 'Workflow has been added',
    runs: {
        search: 'Search',
        'search-by-id': 'Search by ID',
        list: {
            id: 'ID',
            name: 'Name',
            status: 'Status',
            created: 'Started at',
            duration: 'Duration',
            revision: 'Revision',
        },
        'empty-filtered-list': 'List is empty',
    },
}
